import { render, staticRenderFns } from "./EditarNoticia.vue?vue&type=template&id=e58b421e&"
import script from "./EditarNoticia.vue?vue&type=script&lang=js&"
export * from "./EditarNoticia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports